import * as React from 'react';
import {
    root,
    IComponentViewController,
    SERVICE_VIEW_CLASSNAME,
    SERVICE_VIEW_RENDERED_ATTRIBUTE
} from '@estee/elc-universal-utils';
import { observer } from 'mobx-react';
import { ErrorBoundary } from '@estee/elc-telemetry';
import { withEvents } from './EventsHoc';
import { ViewManager } from '../Service/ViewsManager/ViewManager';
import { getViewsManager } from '../Service/ViewsManager/ViewsManager';

interface IRestProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

interface IProps extends IRestProps {
    name: string;
    config?: object;
    serviceName: string;
}

interface IState {
    viewManager: ViewManager;
    name: string;
}

@observer
export class ServiceView extends React.Component<IProps, IState> {
    private viewController: IComponentViewController | null | undefined;

    static getDerivedStateFromProps(props: IProps, state: IState) {
        if (props.name !== state.name) {
            const { version = '' } = root.ServiceRegistry[props.serviceName] || {};
            const viewsManager = getViewsManager(props.serviceName, version);

            return {
                name: props.name,
                viewManager: viewsManager.getViewManager(props.name) as ViewManager
            };
        }

        return null;
    }

    constructor(props: IProps) {
        super(props);
        const { version = '' } = root.ServiceRegistry[props.serviceName] || {};
        const viewsManager = getViewsManager(props.serviceName, version);

        this.state = {
            name: props.name,
            viewManager: viewsManager.getViewManager(props.name) as ViewManager
        };
        this.viewController = this.state.viewManager.controllerFromView;
    }

    private async getComponentFromViewManager() {
        const { viewManager } = this.state;

        await viewManager.loadComponent();
        this.viewController = viewManager.controllerFromView;
        this.forceUpdate();
    }

    private getComponent = () => {
        const Component = this.state.viewManager.module;

        if (Component) {
            return <Component config={this.props.config} viewController={this.viewController} />;
        }

        return null;
    };

    public async componentDidUpdate(prevProps: IProps) {
        if (prevProps.name !== this.props.name) {
            await this.getComponentFromViewManager();
        }
    }

    public async componentDidMount() {
        if (!this.state.viewManager.module) {
            await this.getComponentFromViewManager();
        }
    }

    public render() {
        const { name, serviceName } = this.props;

        const ServiceChild = this.getComponent();

        const serviceMountPointAttributes = {
            [SERVICE_VIEW_RENDERED_ATTRIBUTE]: name,
            className: SERVICE_VIEW_CLASSNAME
        };

        return (
            <div {...serviceMountPointAttributes}>
                <ErrorBoundary name={name} serviceName={serviceName}>
                    {ServiceChild}
                </ErrorBoundary>
            </div>
        );
    }
}

export const ServiceViewEvents = withEvents(ServiceView);
